import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors, Text } from "../../config/Constants";
import Button from "../Button";

const ManageParksHeader= () => {
  const navigate = useNavigate();

  return (
    <StyledManageParkHeader>
    <StyledPageHeader>{'Entertainment Park'}</StyledPageHeader>
    <ManageParkHeaderActions>
      <Button
        variant="filled"
        label={"Add Park"}
        color={Colors.red}
        onClick={() => navigate("/admin/add-park")}
      ></Button>
    </ManageParkHeaderActions>
  </StyledManageParkHeader>
  );
};



const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledManageParkHeader = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding-bottom: 1rem;
  align-items: center;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0.5rem;
  }
`;

const ManageParkHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    padding: 1.5rem;
  }
`;



export default ManageParksHeader;
